<div class="stock-ag-table-actions">
  <button class="lum-button lum-button--secondary" [matMenuTriggerFor]="menu">
    Actions <i class="flaticon-more ml-2"></i>
  </button>
  <mat-menu class="lum-mat-menu" #menu="matMenu">
    <button mat-menu-item (click)="onCreateSalesOrder()">
      Create Sales Order
    </button>
    <button mat-menu-item (click)="onPullOrders()">Pull Orders</button>
    <button mat-menu-item (click)="onPullSingleOrder()"> Pull Single Order </button>
    <button mat-menu-item (click)="onPullOrderShipments()"
      >Pull Order Shipments</button
    >
    <button mat-menu-item (click)="onClickCreateCustomField()">
      Create Custom Field
    </button>
    <button mat-menu-item [matMenuTriggerFor]="groupMenu">Group By</button>
    <button
      mat-menu-item
      [matMenuTriggerFor]="bulkActionMenu"
      [disabled]="selectedRows.length <= 0 && !isSelectAllRows"
    >
      Bulk Actions ({{
        isSelectAllRows && allSelectableRowCount
          ? allSelectableRowCount
          : selectedRows.length
      }})
    </button>
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="onClearGridState()">Reset to Default</button>
  </mat-menu>
  <!-- Group By -->
  <mat-menu #groupMenu="matMenu">
    <button mat-menu-item (click)="onGroupByChange('')">
      <span>None</span>
    </button>
    <mat-divider></mat-divider>
    <ng-container *ngFor="let group of groupByOptions; trackBy: trackByLabel">
      <button mat-menu-item (click)="onGroupByChange(group.field)">
        <mat-radio-group [(ngModel)]="currentGroupBy">
          <mat-radio-button [value]="group.field">
            {{ group.label }}
          </mat-radio-button>
        </mat-radio-group>
      </button>
    </ng-container>
  </mat-menu>
  <!-- Bulk Action -->
  <mat-menu #bulkActionMenu="matMenu">
    <button
      mat-menu-item
      [ngbPopover]="!canCreatePicklist ? toolTipMessage : ''"
      [popoverTitle]="
        !canCreatePicklist ? 'Can not procced to Create Picklist.' : ''
      "
      triggers="click:mouseleave"
      (click)="onBulkCreatePicklist()"
    >
      Create Picklist
    </button>
    <button
      mat-menu-item
      triggers="click:mouseleave"
      (click)="onBulkCreateIndividualPicklistsPerOrder()"
    >
      Create Individual Picklists per Order
    </button>
    <button
      *ngIf="!isSelectAllRows"
      mat-menu-item
      (click)="onPreviewPicklistItems()"
    >
      Preview Picklist Items
    </button>
    <button mat-menu-item (click)="onBulkUpdateTags()">Update Tags</button>
    <button mat-menu-item (click)="onBulkUpdateOrderStatus()">
      Update Order Status
    </button>

    <button
      *ngIf="!isSelectAllRows"
      mat-menu-item
      (click)="onBulkExportPackingSlips()"
    >
      Export Packing Slip(s)
    </button>

    <button
      *ngIf="!isSelectAllRows"
      mat-menu-item
      (click)="onBulkExportSalesOrders()"
    >
      Export Sales Order(s)
    </button>

    <button
      *ngIf="!isSelectAllRows"
      mat-menu-item
      (click)="onBulkExportFulfillmentAllocationSheet()"
    >
      Export Fulfillment Allocation Sheet
    </button>

    <button mat-menu-item (click)="onGetOrderUpdates()"> Get Order Updates </button>

    <button *ngIf="canShipOrders" mat-menu-item (click)="onOpenShipOrders()">
      Fulfill Orders
    </button>

    <button
      *ngIf="ftFulfillmentOrderShipmentSplits"
      mat-menu-item
      (click)="onAutoGenerateFulfillmentOrders()"
    >
      Auto Generate Fulfillment Orders
    </button>

    <button
      *ngIf="!isSelectAllRows && selectedRows.length > 0"
      mat-menu-item
      (click)="onBatchCreateInvoices()"
    >
      Create Invoices
    </button>

    <button
      *ngIf="!isSelectAllRows && selectedRows.length > 0"
      mat-menu-item
      (click)="onBulkDelete()"
    >
      Delete
    </button>

    <button
      *ngIf="!isSelectAllRows && selectedRows.length > 0"
      mat-menu-item
      (click)="onUnpostOrders()"
    >
      Unallocate Orders
    </button>
  </mat-menu>
</div>
